var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"footer",attrs:{"absolute":""}},[_c('v-row',{staticClass:"content"},[_c('v-spacer'),_c('label',[_vm._v(_vm._s(_vm.$store.getters.appVersion))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }